import posthog from "posthog-js";

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN!, {
  api_host: "/ingest",
  ui_host: "https://eu.posthog.com",
  defaults: "2026-01-30",
  capture_exceptions: true,
  // No surveys run on this site; skips the 33 KB surveys.js on every page.
  disable_surveys: true,
  // Cookieless: no cookies or storage on the visitor's device, so no consent
  // banner is needed. Identity is a daily server-side hash; replay stays off.
  cookieless_mode: "always",
  disable_session_recording: true,
  debug: process.env.NODE_ENV === "development",
});
